/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import Image from 'next/image';
// libraries
import { Checkbox } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import axios from 'axios';
import { sha256 } from 'js-sha256';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { FaCheck, FaChevronDown, FaChevronUp, FaPinterest, FaTelegramPlane } from "react-icons/fa";
import { IoIosArrowBack } from 'react-icons/io';
import { TailSpin } from 'react-loader-spinner';
// utils
import { AppPhoneInput } from '../../../../../../components/input_phone/AppPhoneInput';
import { trackLead } from '../../../../../../components/whatsAppButton/WhatsAppButton';
import {
    sendUser,
    viewProperties
} from '../../../../../../services/properties';
import {
    NumeroFormatado, arrumaData, formatarDataEntrega, hexToRgba, interesseInicial, isColorLight, toPrice,
    trackEvent,
    useWindowSize
} from '../../../../../../utils/FunctionsGlobals';
import { precoOuTexto } from '../../../../../../components/pieces/idiomas/PrecoMoeda';
import { temSeletorIdiomas } from '../../../../../../utils/moedaSite';
import { canShowPropertyAddress, formatPropertyAddress } from '../../../../../../utils/propertyAddress';
import { resolveSiteWhatsAppUrl } from '../../../../../../utils/site2524WhatsApp';
import { whatsParaImobiliaria } from '../../../../../../utils/whatsappImobiliaria';
import { usaDescricaoEsquerda } from '../../../../../../utils/descricaoAlinhadaEsquerda';
import { textosSecoesDoSite } from '../../../../../../utils/textosSecoesPorSite';
import { trackMetaEvent, genMetaEventId, resolvePixelId, sendMetaCapiEvent, metaPrecoParams } from '../../../../../../utils/metaPixel';
import { finalidadeAceiteForm } from '../../../../../../utils/textoAceiteForm';
import { ehModeloHorizonte } from '../../../../../../components/pieces/horizonte/horizonte';
import { ehModeloAurora } from '../../../../../../components/pieces/aurora/aurora';
import { ehModeloPanorama } from '../../../../../../components/pieces/panorama/panorama';
import { ehModeloLarissa } from '../../../../../../components/pieces/larissa/larissa';
import { ehModeloMetropole } from '../../../../../../components/pieces/metropole/metropole';
import { ehModeloInternacional, paletaInternacional } from '../../../../../../components/pieces/internacional/internacional';
import { ehModeloNorte as ehFichaNorte, paletaNorte } from '../../../../../../components/pieces/norte/norte';
import { ehModeloCampo as ehFichaCampo, paletaCampo } from '../../../../../../components/pieces/campo/campo';
import styles from './DetailsPiecesProperties.module.css';
import { temTelefonePorOperacao, telefoneOperacao } from '../../../../../../utils/telefoneOperacao';

const DetailsPiecesProperties: React.FC<{
    detailsProperties: any;
    managerActual: any;
    site: any;
    origin?: any;
    codsite?: any;
    delegar_ao_agenciador?: any;
}> = ({ detailsProperties, managerActual, site, origin, codsite, delegar_ao_agenciador }) => {
    // constants
    const size = useWindowSize();
    // Modelo "Horizonte" (topo 11): a skin vem do CSS gateado por [data-modelo='horizonte'] (raiz da
    // ficha). Aqui só saem os estilos INLINE que o CSS não vence sem !important (cor do botão,
    // bordas dos campos e das linhas) e o rótulo do preço vira sobretítulo. Fora dele: igual a hoje.
    const horizonte = ehModeloHorizonte(site);
    // Aurora (topo 10) / Panorama (topo 13): a MESMA troca do Horizonte (skin no CSS gateado por
    // [data-modelo='aurora'|'panorama'] na raiz). `modeloAP` tira também as cores inline do formulário
    // lateral e do corretor, que nesses modelos viram painéis próprios (cartão branco / degradê marinho).
    // Larissa (topo 14): mesma troca (cartões brancos de raio 16 no formulário e no corretor), skin em
    // [data-modelo='larissa']; `larissa` ainda tira a cor inline do título/código/preço (viram --lr-texto).
    // Internacional (topo 16): a MESMA troca do Larissa (skin em [data-modelo='internacional']; cor inline do título/código/preço sai).
    // Norte (topo 17): idem (skin em [data-modelo='norte']: cartão de contato branco com sombra, pílula sólida, preço 32/500).
    // Campo (topo 18): idem (skin em [data-modelo='campo']: cartão de contato raio 20 sobre o papel, pílula sólida, preço 32/800).
    const larissa = ehModeloLarissa(site) || ehModeloInternacional(site) || ehFichaNorte(site) || ehFichaCampo(site);
    // Metrópole (topo 15): a mesma troca do Larissa (cartões brancos de raio 8, skin em [data-modelo='metropole']).
    const metropole = ehModeloMetropole(site);
    const modeloAP = ehModeloAurora(site) || ehModeloPanorama(site) || larissa || metropole;
    const modeloNovo = horizonte || modeloAP;
    const stylesButton = modeloNovo ? { cursor: "pointer" } : {
        backgroundColor: `${site?.cor2 || '#00a93a'}`,
        color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13,
        cursor: "pointer"
    };
    const mobileInterestButtonStyle = site?.id === 2473
        ? { backgroundColor: 'rgb(225 193 146)', color: site?.cor11 || '#1f1f1f' }
        : site?.id === 1730
        ? { backgroundColor: 'rgb(0, 172, 167)' }
        : {};
    // 2451: todos os corretores caem no mesmo perfil do site (@unio_imoveis)
    const ocultarInstagramCorretor = site?.id == 2451;
    const ocultarAgendarVisitaCorretor = site?.id == 2451;
    // 1609 e 1892 (#1337): cliente pediu o botão "Converse pelo Whatsapp" fora do card do corretor
    const ocultarWhatsappCorretor = Number(site?.id) === 1609 || Number(site?.id) === 1892;

    // useState
    const descricao_limpa = detailsProperties?.descricao ? detailsProperties?.descricao.replaceAll('<br>', '\n').replaceAll("&lt;br&gt;", '\n') : detailsProperties?.descricao;

    const router = useRouter();
    const { utm_campaign } = router.query;
    const { utm_source } = router.query;
    const { utm_medium } = router.query;
    const { utm_id } = router.query;
    const [name, setName] = useState('');
    const [telephone, setTelephone] = useState('');
    const [email, setEmail] = useState('');
    const [openForm, setOpenForm] = useState('close');
    const [existUser, setExistUser] = useState<any>(null);
    const [url, setUrl] = useState<any>(null);
    const [acceptPolitic, setAcceptPolitic] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [isEffect, setIsEffect] = useState(false);
    const [interesse, setInteresse] = useState<any>(interesseInicial(detailsProperties, site));
    const [processando, setProcessando] = useState(false);

    const normalizeCaracteristicaNome = (value: any) => {
        const nome = String(value || '')
            .replace(/\u00A0/g, ' ')
            .replace(/[\u200B-\u200D\uFEFF]/g, '')
            .replace(/\s+/g, ' ')
            .trim();

        return nome
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]/g, '');
    };

    const caracteristicasFiltradas = (() => {
        const caracteristicas = Array.isArray(detailsProperties?.caracteristicas)
            ? detailsProperties.caracteristicas
            : [];

        const unidade: string[] = [];
        const condominio: string[] = [];
        // Quando a MESMA característica está marcada nos dois tipos, quem vence é o
        // CONDOMÍNIO (regra do produto: "marcando os dois, ela aparece apenas no bloco
        // Condomínio" — precedente do ticket #931). Por isso o condomínio é montado
        // PRIMEIRO e a unidade pula o que já foi exibido.
        const nomesExibidos = new Set<string>();

        caracteristicas.forEach((item: any) => {
            const tipo = String(item?.caracteristica?.tipo || '').trim().toLowerCase();
            const nome = String(item?.caracteristica?.nome || '').trim();
            const nomeNormalizado = normalizeCaracteristicaNome(nome);

            if (tipo !== 'condominio' || !nomeNormalizado || nomesExibidos.has(nomeNormalizado)) {
                return;
            }

            nomesExibidos.add(nomeNormalizado);
            condominio.push(nome);
        });

        caracteristicas.forEach((item: any) => {
            const tipo = String(item?.caracteristica?.tipo || '').trim().toLowerCase();
            const nome = String(item?.caracteristica?.nome || '').trim();
            const nomeNormalizado = normalizeCaracteristicaNome(nome);

            if (tipo !== 'unidade' || !nomeNormalizado || nomesExibidos.has(nomeNormalizado)) {
                return;
            }

            nomesExibidos.add(nomeNormalizado);
            unidade.push(nome);
        });

        return { unidade, condominio };
    })();

    const calcularTotal = (precoLocacao?: number, precoCondominio?: number, precoIptu?: number): number => {
        const locacao = precoLocacao || 0;
        const condominio = precoCondominio || 0;
        const iptu = precoIptu || 0;

        return locacao + condominio + iptu;
    };
    // Internacional (topo 16): a página é SEMPRE clara (varsInternacionalPagina) — a cor do texto não segue a cor5 do
    // tenant (no cs1722, quase-preta → texto creme sobre o cinza-claro = invisível): é a tinta do modelo.
    // Norte (topo 17): idem — página BRANCA da referência: o texto é a tinta do modelo (--nt-tinta).
    // Campo (topo 18): idem — página de PAPEL: o texto é a tinta do modelo (--cp-tinta).
    const internacionalFicha = ehModeloInternacional(site) || ehFichaNorte(site) || ehFichaCampo(site);
    const cor_font = ehFichaNorte(site) ? paletaNorte(site).tinta : ehFichaCampo(site) ? paletaCampo(site).tinta : internacionalFicha ? paletaInternacional(site).tinta : isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;
    // Unidade do TERRENO (tbl_imovel.AreaTipo). No cadastro do CRM esse campo se chama
    // "Tipo de medida (terreno)" e só o Terreno total usa a unidade escolhida — área total,
    // privativa, útil e construída são SEMPRE m². Ticket #1070.
    const rawAreaTipo = String(detailsProperties?.area_tipo || '').trim();
    const areaTipo = rawAreaTipo && rawAreaTipo.toLowerCase() !== 'null' ? rawAreaTipo : 'm²';
    const isSite1791 = Number(site?.id) === 1791;
    // INC-0193 (cs1630): só neste site a barra "Compartilhe" ganha respiro acima no celular.
    const isSite1630 = Number(site?.id) === 1630;
    // INC-0157 (cs2021): justify abre "buracos" em texto sem espaço após vírgula.
    const alinhamentoDescricao = usaDescricaoEsquerda(site?.id) ? { textAlign: 'left' as const } : {};
    const isSite1892 = Number(site?.id) === 1892;
    const isSite2155 = Number(site?.id) === 2155;
    const isSite2537 = Number(site?.id) === 2537;
    const isSite2551 = Number(site?.id) === 2551;
    // cs899 (20/10): sem a "Descrição final" da empresa na ficha do imóvel (os portais continuam com ela).
    const isSite899 = Number(site?.id) === 899;
    // cs2639 (utils/textosSecoesPorSite): títulos dos blocos em frase ("Características do imóvel")
    // e os VALORES do bloco de características em negrito. Fora da lista, tudo como sempre foi.
    // Horizonte: títulos em frase ("Características do imóvel"), como na home do modelo
    const titulosEmFrase = !!textosSecoesDoSite(site?.id).titulosEmFrase || modeloNovo;
    const site2551CondominioPrefix = isSite2551 ? '+/- ' : '';
    // 21/10: preço na moeda do idioma — fora do gate (seletor de idiomas desligado) o texto é o de sempre, byte a byte.
    const precoVivo = temSeletorIdiomas(site);
    const simboloMoeda = detailsProperties?.moeda_imovel != site?.moeda_tipo ? detailsProperties?.moeda_imovel : site?.moeda_tipo;
    const site2551CondominioAddendum = isSite2551 ? ' + CONSUMOS/ENGARGOS' : '';
    const hasVenda = Number(detailsProperties?.venda) > 0 || detailsProperties?.venda === true;
    const hasAluguel = Number(detailsProperties?.aluguel) > 0 || detailsProperties?.aluguel === true;
    const propertyTransaction: 'venda' | 'locacao' = hasAluguel && !hasVenda ? 'locacao' : 'venda';
    const shouldShowSite2551RentalWarnings = isSite2551 && hasAluguel && !hasVenda;
    const rentalWarnings = [
        'Atenção: móveis e utensílios que por ventura apareçam nas fotos, não fazem parte da locação ou venda dos imóveis, salvo informação expressa da inclusão dos mesmos na descrição do imóvel abaixo e no contrato de locação ou de compra e venda.',
        'Os imóveis disponibilizados para locação e para venda, estão com as metragens aproximadas. Caso o pretendente a locação e/ou compra, tenha interesse em saber a metragem real do imóvel, o mesmo deverá procurar a Imobiliária Hachbart. As metragens das vagas de garagem, estão inclusas nas metragens dos imóveis, seguindo o que está no comprovante de titularidade e no IPTU do imóvel. Dúvidas, consultar atendente do setor de aluguel e/ou vendas.',
        'Os valores e as condições de pagamento dos imóveis podem sofrer alterações sem prévio aviso, seguindo determinação dos proprietários, órgãos e administradoras competentes. Por este motivo, solicitamos a confirmação com nossos consultores.',
        'CONFIRMAÇÃO DE VALOR: O valor da taxa condominial informado antes da locação é aproximado, podendo sofrer alterações, portanto o(s) Locatário(s) deverá(ão) confirmar esta informação com o síndico/Administradora do condomínio.',
        'Consultar a imobiliária e a administração em relação a animal de estimação.'
    ];

    const getPropertyUrl = () => (
        typeof window !== 'undefined'
            ? `${window.location.origin}${window.location.pathname.replaceAll("%20", "-").replaceAll(" ", "-")}`
            : ''
    );

    const cleanPhone = (phone?: string) => (phone || '').replace(/\D/g, '');

    const resolveWhatsappPhone = (
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = propertyTransaction
    ) => {
        if (isSite1791) {
            if (transaction === 'locacao' && hasAluguel && !hasVenda) {
                return '555184010353';
            }
            return '5551984012364';
        }
        // SD-0049 (gate cs2532): número por operação vindo do cadastro (tel1 venda / tel3 locação)
        if (temTelefonePorOperacao(site)) {
            return cleanPhone(telefoneOperacao(site, transaction));
        }

        return cleanPhone(fallbackPhone);
    };

    const buildWhatsappUrl = (
        message: string,
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = propertyTransaction,
        forceInternational?: boolean
    ) => {
        const phone = resolveWhatsappPhone(fallbackPhone, transaction);
        if (!phone) return '#';

        const international = forceInternational ?? managerActual?.internacional;
        const prefix = isSite1791 || international ? '' : '55';
        return resolveSiteWhatsAppUrl(site, `https://api.whatsapp.com/send?phone=${prefix}${phone}&text=${message}`);
    };
    const defaultSitePhone = isSite2537
        ? site?.Dados?.tel3 || site?.Dados?.tel1 || site?.Dados?.tel2
        : site?.Dados?.tel1 || site?.Dados?.tel2;

    const managerOrSitePhone = (managerActual?.id)
        ? (
            managerActual?.telefone ||
            managerActual?.telefone_2
        )
        : (
            defaultSitePhone
        );
    const managerPhone = managerActual?.internacional
        ? (
            managerActual?.telefone ||
            managerActual?.telefone_2
        )
        : (
            site?.id == 2455
                ? site?.Dados?.tel1
                : (managerActual?.telefone || managerActual?.telefone_2)
        );
    // Norte (topo 17): o link do imóvel nos hrefs do WhatsApp só existe no cliente (window) — no SSR é '' e o href
    // não bate na hidratação. No Norte o link entra DEPOIS de montar (SSR e 1º render iguais). Demais sites: como sempre.
    const [urlMontadaNorte, setUrlMontadaNorte] = useState('');
    // Campo (topo 18): a mesma entrada pós-montagem do Norte.
    const fichaNorte = ehFichaNorte(site) || ehFichaCampo(site);
    useEffect(() => {
        if (fichaNorte) setUrlMontadaNorte(getPropertyUrl());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fichaNorte, detailsProperties?.id]);
    const propertyUrl = fichaNorte ? urlMontadaNorte : getPropertyUrl();
    const shouldUseSite2155VendaWhatsapp = isSite2155 && hasVenda;
    const whatsappInfoPhone = shouldUseSite2155VendaWhatsapp
        ? '32984059791'
        : isSite2551 && hasAluguel
        ? '5527998760688'
        : managerOrSitePhone;
    const whatsappInfoForceInternational = shouldUseSite2155VendaWhatsapp
        ? false
        : isSite2551 && hasAluguel
        ? true
        : undefined;
    const whatsappInfoUrl = whatsParaImobiliaria(buildWhatsappUrl(
        `Olá, vi esse imóvel no site quero mais informações - Link: ${propertyUrl}`,
        whatsappInfoPhone,
        propertyTransaction,
        whatsappInfoForceInternational
    ), site, !shouldUseSite2155VendaWhatsapp && managerActual?.id ? managerActual : null, 'I');
    const whatsappInfoUrlAlt = whatsParaImobiliaria(buildWhatsappUrl(
        `Olá, vi este imóvel no site. Link: ${propertyUrl}`,
        whatsappInfoPhone,
        propertyTransaction,
        whatsappInfoForceInternational
    ), site, !shouldUseSite2155VendaWhatsapp && managerActual?.id ? managerActual : null, 'I');
    const whatsappVisitUrl = whatsParaImobiliaria(buildWhatsappUrl(
        `Olá, quero agendar uma visita ao imóvel Link: ${propertyUrl}`,
        isSite2551 && hasAluguel ? '27998760688' : managerOrSitePhone
    ), site, managerActual?.id ? managerActual : null, 'I');
    const managerWhatsappUrl = whatsParaImobiliaria(buildWhatsappUrl(
        `Olá, vi este imóvel no site. Link: ${propertyUrl}`,
        isSite1892 ? '51998800111' : managerPhone,
        propertyTransaction,
        isSite1892 ? false : managerActual?.internacional
    ), site, managerActual?.internacional || site?.id != 2455 ? managerActual : null, 'I');

    const renderUrl = () => {
        return `https://${site?.site}${router.asPath}`;
    };

    const [expandido, setExpandido] = useState(false); // Estado para controlar se o texto está expandido
    const [exibirBotao, setExibirBotao] = useState(false); // Estado para controlar a visibilidade do botão
    const textoRef = useRef<HTMLDivElement | null>(null); // Referência para a div contendo o texto

    useEffect(() => {
        if (textoRef.current) {
            const alturaTexto = textoRef.current.scrollHeight; // Altura real do texto dentro da div
            const alturaMaxima = 10 * 20; // 20rem convertido para pixels (1rem = 16px padrão)
            setExibirBotao(alturaTexto > alturaMaxima); // Exibe o botão apenas se o texto for maior que o limite
        }
    }, []); // Executa apenas uma vez após o componente ser montado

    const Desc2 = (texto: any) => {
        if (site?.id === "2015") {
            if (texto.includes("https://")) {
                const url = texto.split("https://")[1];
                const textoNew = texto.replace(
                    "https://" + url,
                    `<a href="https://${url}" target="_blank" rel="noopener noreferrer">https://${url}</a>`
                );
                return textoNew;
            }
            return texto;
        }
        return texto.replaceAll("<br>", '\n');
    };

    // Norte (topo 17): o texto de abertura/descrição vem em HTML do CRM (com <p> dentro) — num <p> isso quebra a
    // hidratação (p dentro de p); no Norte o invólucro é <div>. Demais sites: <p> de sempre (zero diff).
    const TagTexto = ehFichaNorte(site) || ehFichaCampo(site) ? 'div' : 'p';
    function Desc(texto: any){
        if(site?.id == "2015"){
            if(texto.includes("https://")){
                const url = texto.split("https://")[1];
                const textoNew = texto.replace("https://"+url,`<a href="https://${url}" target="_blank" rel="noopener noreferrer">https://${url}</a>`)
                return (<TagTexto className={styles.description_properties} dangerouslySetInnerHTML={{ __html: textoNew }} style={{color: cor_font, ...alinhamentoDescricao}}></TagTexto>)
            }
            return(<TagTexto className={styles.description_properties} dangerouslySetInnerHTML={{ __html: texto }} style={{color: cor_font, ...alinhamentoDescricao}}></TagTexto>)
        }
        return(<TagTexto className={styles.description_properties} dangerouslySetInnerHTML={{ __html: texto }} style={{color: cor_font, ...alinhamentoDescricao}}></TagTexto>)
    }

    function Desc1(texto: any){
        if(site?.id == "2015"){
            if(texto.includes("https://")){
                const url = texto.split("https://")[1];
                const textoNew = texto.replace("https://"+url,`<a href="https://${url}" target="_blank" rel="noopener noreferrer">https://${url}</a>`)
                return (<TagTexto className={styles.description_properties} style={{color: cor_font, ...alinhamentoDescricao}} dangerouslySetInnerHTML={{ __html: textoNew }}></TagTexto>)
            }
            return(<TagTexto className={styles.description_properties} style={{color: cor_font, ...alinhamentoDescricao}} dangerouslySetInnerHTML={{ __html: texto }}></TagTexto>)
        }
        return(<TagTexto className={styles.description_properties_local} style={{color: cor_font, ...alinhamentoDescricao}} dangerouslySetInnerHTML={{ __html: texto }}></TagTexto>)
    }

    useEffect(() => {
        setUrl(renderUrl);
    }, []);

    // methods
    const renderSvg = (label: string) => {
        if (label === 'Tipo do Imóvel') {
            return (
                <svg
                    viewBox="0 0 16 16"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill={cor_font}
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fillRule="evenodd"
                        d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
                    ></path>
                    <path
                        fillRule="evenodd"
                        d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
                    ></path>
                </svg>
            );
        }
        if (
            [
                'Área Construída',
                'Área Total',
                'Terreno',
                'Dimensões',
                'Área Privativa',
                'Área Útil',
            ].includes(label)
        ) {
            return (
                <svg
                    viewBox="0 0 16 16"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path d="M3.5.5A.5.5 0 0 1 4 1v13h13a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2H3.5a.5.5 0 0 1-.5-.5V4H1a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 .5-.5zm2.5 3a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4H6.5a.5.5 0 0 1-.5-.5z"></path>
                </svg>
            );
        }
        if (['Dormitórios', 'Quartos', 'Suítes'].includes(label)) {
            return (
                <svg
                    viewBox="0 0 640 512"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fill="currentColor"
                        d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                    ></path>
                </svg>
            );
        }
        if (label === 'Banheiros') {
            return (
                <svg
                    viewBox="0 20 512 512"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fill="currentColor"
                        d="M32 384a95.4 95.4 0 0 0 32 71.09V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h256v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-40.91A95.4 95.4 0 0 0 480 384v-48H32zm464-128H80V69.25a21.26 21.26 0 0 1 36.28-15l19.27 19.26c-13.13 29.88-7.61 59.11 8.62 79.73l-.17.17a16 16 0 0 0 0 22.59l11.31 11.31a16 16 0 0 0 22.63 0L283.31 81.94a16 16 0 0 0 0-22.63L272 48a16 16 0 0 0-22.62 0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62l-19.26-19.27A69.25 69.25 0 0 0 32 69.25V256H16a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16z"
                    ></path>
                </svg>
            );
        }
        if (label === "Posição Solar"){
            return (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="24px" height="24px">
                    <path d="M 15 3 L 15 8 L 17 8 L 17 3 Z M 7.5 6.09375 L 6.09375 7.5 L 9.625 11.0625 L 11.0625 9.625 Z M 24.5 6.09375 L 20.9375 9.625 L 22.375 11.0625 L 25.90625 7.5 Z M 16 9 C 12.144531 9 9 12.144531 9 16 C 9 19.855469 12.144531 23 16 23 C 19.855469 23 23 19.855469 23 16 C 23 12.144531 19.855469 9 16 9 Z M 16 11 C 18.773438 11 21 13.226563 21 16 C 21 18.773438 18.773438 21 16 21 C 13.226563 21 11 18.773438 11 16 C 11 13.226563 13.226563 11 16 11 Z M 3 15 L 3 17 L 8 17 L 8 15 Z M 24 15 L 24 17 L 29 17 L 29 15 Z M 9.625 20.9375 L 6.09375 24.5 L 7.5 25.90625 L 11.0625 22.375 Z M 22.375 20.9375 L 20.9375 22.375 L 24.5 25.90625 L 25.90625 24.5 Z M 15 24 L 15 29 L 17 29 L 17 24 Z"/>
                </svg>
            );
        }
        if (label === 'Vagas') {
            return (
                <svg
                    viewBox="0 20 512 512"
                    height="24px"
                    width="24px"
                    aria-hidden="true"
                    focusable="false"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                >
                    <path
                        fill="currentColor"
                        d="M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                    ></path>
                </svg>
            );
        }
    };
    // Horizonte: o rótulo do preço ("Venda", "Aluguel"...) vira sobretítulo acima do valor;
    // fora dele, o MESMO texto de sempre ("Venda: R$ 1,00").
    // Aurora/Panorama: idem, com o valor num span próprio (Aurora: pílula sólida cor2, como no card).
    // 21/10: `valor` pode ser o <PrecoMoeda> (precoOuTexto); fora do gate segue string e o texto é o de sempre.
    const textoPreco = (rotulo: string, valor: React.ReactNode) => horizonte
        ? <><span className={styles.rotulo_preco}>{rotulo}</span>{valor}</>
        : modeloAP
        ? <><span className={styles.rotulo_preco}>{rotulo}</span><span className={styles.valor_preco}>{valor}</span></>
        : typeof valor === 'string' ? `${rotulo}: ${valor}` : <>{`${rotulo}: `}{valor}</>;
    const RenderDetails = (label: string, value: string) => {
        return (
            <div className={styles.container_caracters} style={modeloNovo ? undefined : {borderBottom: `1px solid ${hexToRgba(cor_font,0.1)}`}}>
                <div className={styles.adjust_title_and_icon} style={{color: cor_font}}>
                    {label != "Data de Entrega" ? renderSvg(label) : null}
                    <label className={isSite2551 ? `${styles.title_info_caracters} ${styles.font_mini}` : styles.title_info_caracters} data-fm style={{color: cor_font}}>
                        {label}
                    </label>
                </div>
                <label className={isSite2551 ? `${styles.result_info_caracters} ${styles.font_mini}` : titulosEmFrase ? `${styles.result_info_caracters} ${styles.valorNegrito}` : styles.result_info_caracters} data-fm style={{color: cor_font}}>{value}</label>
            </div>
        );
    };

    // const formatDate = (timestamp: string | number): string => {
    //     const date = new Date(Number(timestamp)); // Converte para objeto Date
    //     const currentDate = new Date(); // Data atual

    //     if (date > currentDate) {
    //       const monthNames = [
    //         "Janeiro",
    //         "Fevereiro",
    //         "Março",
    //         "Abril",
    //         "Maio",
    //         "Junho",
    //         "Julho",
    //         "Agosto",
    //         "Setembro",
    //         "Outubro",
    //         "Novembro",
    //         "Dezembro",
    //       ];

    //       const month = monthNames[date.getMonth()]; // Nome do mês (0-11)
    //       const year = date.getFullYear(); // Ano completo

    //       return `${month} de ${year}`; // Formato: "Mês de Ano"
    //     }

    //     return ""; // Para datas no passado
    // }

    const RenderInfoAdditionals = (label: string, x: any) => {
        return (
            <div className={styles.info_additional} key={x} style={{color: cor_font}}>
                <FaCheck title="Icone Done" style={{color: cor_font}} height={15} width={15}/>
                <label className={styles.margin} style={{color: cor_font}}>{label}</label>
            </div>
        );
    };

    const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setName(value);
    };

    const onChangeTelephone = (value: string) => {
        setTelephone(value);
    };

    const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setEmail(value);
    };

    const selectTransacao = async () => {
        if(interesse == "Venda"){
            setInteresse("Aluguel")
        } else {
            setInteresse("Venda")
        }
    }

    function isPhoneNumberValid(phoneNumber: string): boolean {
        // Remove todos os caracteres não numéricos
        const cleanedNumber = phoneNumber.replace(/\D/g, '');

        // Verifica se todos os caracteres são iguais
        const allEqual = new Set(cleanedNumber).size === 1;

        // Retorna true se não forem todos iguais
        return !allEqual;
    }

    const actionSendUser = async () => {
        if (name != '' && email != '' && telephone != '') {
            const phone = telephone.replace(/[^0-9]/g, '');
            const valida = isPhoneNumberValid(phone)
            var re = /\S+@\S+\.\S+/;
            if (phone.length > 9 && phone.length < 17 && (site?.internacional || phone.length < 12) && valida) {
                if (re.test(email) == true) {
                    if (acceptPolitic) {
                        if (!processando) {
                            setProcessando(true);
                            setLoadingForm(true);
                            let getSendUser: any = null;
                            if (site?.id == 2398) {
                                const webhookPayload = {
                                    nome: name,
                                    email,
                                    telefone: telephone,
                                    mensagem: 'Interesse no im?vel ' + detailsProperties?.id,
                                    id_imovel: detailsProperties?.id,
                                    referencia: detailsProperties?.referencia,
                                    origem: origin,
                                    codsite,
                                    transacao_selecionada: interesse ? interesse : '',
                                    delegar_ao_agenciador: delegar_ao_agenciador ? 1 : 0,
                                    id_filiado: managerActual?.id && delegar_ao_agenciador ? managerActual?.id : 0,
                                    utm_campaign,
                                    utm_source,
                                    utm_medium,
                                    utm_id,
                                    site_id: site?.id,
                                    site: site?.site,
                                    internacional: site?.internacional ? true : false,
                                };

                                try {
                                    await axios.post(
                                        'https://webhookprod.watrix.com.br/webhook/93fe510c-8573-4bea-bb30-5584e243c336',
                                        webhookPayload
                                    );
                                } catch (error) {
                                    console.error('Erro ao enviar webhook:', error);
                                }
                            } else {
                                getSendUser = await sendUser(
                                    site?.internacional ? true : false,
                                    JSON.stringify(utm_campaign),
                                    JSON.stringify(utm_source),
                                    JSON.stringify(utm_medium),
                                    JSON.stringify(utm_id),
                                    JSON.stringify('Interesse no im?vel ' + detailsProperties?.id),
                                    JSON.stringify(name),
                                    JSON.stringify(email),
                                    JSON.stringify(telephone),
                                    detailsProperties?.id,
                                    managerActual?.id && delegar_ao_agenciador ? managerActual?.id : 0,
                                    origin,
                                    codsite,
                                    interesse ? interesse : '',
                                    delegar_ao_agenciador ? 1 : 0
                                );
                            }
                            setLoadingForm(false);
                            localStorage.setItem(
                                'user',
                                JSON.stringify({
                                    name,
                                    email,
                                    telephone,
                                    id_client: getSendUser?.atendimento?.id_cliente,
                                })
                            );
                            setOpenForm('concluded');
                            setProcessando(false);

                            if (site?.tag_google_head || site?.google_analytics_head) {
                                // NÃO mande PII para GA/GTM:
                                const gaParams = {
                                source: "property",
                                property_ref: detailsProperties?.referencia,
                                property_id: detailsProperties?.id,
                                listing_type: detailsProperties?.venda ? "venda" : (detailsProperties?.aluguel ? "aluguel" : "na"),
                                city: detailsProperties?.cidade?.nome,
                                neighborhood: detailsProperties?.bairro?.nome,
                                price: detailsProperties?.preco ?? detailsProperties?.preco_loca ?? 0,
                                currency: "BRL",
                                // opcional: padronize com items[] (melhora análises)
                                items: [{
                                    item_id: String(detailsProperties?.referencia ?? detailsProperties?.id),
                                    item_name: detailsProperties?.tipo?.nome ?? "Imóvel",
                                    item_category: "Imóveis",
                                    item_variant: detailsProperties?.bairro?.nome,
                                    price: detailsProperties?.preco ?? detailsProperties?.preco_loca ?? 0,
                                    currency: "BRL",
                                    item_brand: site?.Dados?.empresa,
                                    item_list_name: "property_page",
                                }],
                                };

                                // Dispara para GTM/GA4
                                trackEvent("generate_lead", gaParams);
                                trackEvent("lead_submit_success", gaParams);
                            }

                            if (getSendUser?.atendimento?.id_cliente) {
                                const leadEventId = genMetaEventId();

                                // Lead de BROWSER (Pixel) — dispara sempre que o lead foi salvo
                                // (no-op p/ tenant sem pixel). Compartilha o eventId com o CAPI abaixo.
                                trackMetaEvent(site, 'Lead', {
                                    content_ids: [String(detailsProperties?.id)],
                                    content_type: 'product',
                                    content_name: detailsProperties?.titulo,
                                    lead_source: 'property_contact_form',
                                    ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
                                }, { eventId: leadEventId });

                                // Lead via CAPI (server-side /api/meta-capi): PII hasheada no CLIENTE;
                                // MESMO leadEventId da perna browser → Meta dedupa. Token por host no server.
                                if (resolvePixelId(site?.fb_id_pixel, site?.pixel_facebook_head)) {
                                    const normalizedName = name.trim().toLowerCase();
                                    const normalizedEmail = email.trim().toLowerCase();
                                    const normalizedPhone = telephone.replace(/\D/g, ''); // Apenas números

                                    sendMetaCapiEvent({
                                        site,
                                        eventName: 'Lead',
                                        eventId: leadEventId,
                                        // ESPELHA os params não-PII da perna browser: com adblocker o /tr
                                        // morre e só este endpoint first-party chega com value/conteúdo.
                                        customData: {
                                            content_ids: [String(detailsProperties?.id)],
                                            content_type: 'product',
                                            content_name: detailsProperties?.titulo,
                                            lead_source: 'property_contact_form',
                                            ...metaPrecoParams(detailsProperties?.preco_venda, detailsProperties?.preco_loca),
                                        },
                                        userData: {
                                            fn: [sha256(normalizedName)],
                                            em: [sha256(normalizedEmail)],
                                            ph: [sha256(normalizedPhone)],
                                        },
                                    });
                                }
                            }
                        }
                    } else {
                        alert('Concorde com os termos de uso!');
                    }
                } else {
                    alert('Preencha um email válido!');
                }
            } else {
                alert('Preencha um número de telefone válido!');
            }
        } else {
            alert(
                'Preencha todos os campos do formulário para ver mais fotos!'
            );
        }
    };

    const resetForm = () => {
        setOpenForm('close');
        // setName('');
        // setEmail('');
        // setTelephone('');
    };

    const activeOpenForm = () => {
        setOpenForm('open');
    };

    const renderFormStepOne = (type: 'web' | 'mobile') => {
        return (
            <div className={type === 'web' ? styles.form : styles.form_mobile} style={modeloNovo && type === 'web' ? undefined : {backgroundColor: site?.cor5}}>
                <div className={styles.adjust_header_form}>
                    <IoIosArrowBack
                        onClick={resetForm}
                        size={26}
                        color={cor_font}
                        style={{ cursor: 'pointer' }}
                    />
                    <label className={styles.title_form_one} style={modeloAP ? undefined : {color: cor_font}}>
                        Tenho interesse neste imóvel
                    </label>
                </div>
                <input
                    className={styles.input}
                    placeholder="Nome"
                    id="Nome_id"
                    style={modeloNovo ? undefined : {border: `1px solid ${cor_font}`,color: cor_font}}
                    value={name}
                    onChange={onChangeName}
                />
                <AppPhoneInput
                    id="Telefone_id"
                    value={telephone}
                    onChange={onChangeTelephone}
                    placeholder="Telefone"
                    defaultCountry="BR"
                    width_max={modeloNovo ? undefined : 90}
                    inputHeight={56}
                    limitMaxLength={true}
                    inputClassName={styles.input}
                    inputStyle={modeloNovo ? undefined : { border: `1px solid ${cor_font}`, color: cor_font }}
                    semPais={!site?.internacional ? true : false}
                    includeCountryCode={site?.internacional ? true : false}
                />
                <input
                    className={styles.input}
                    placeholder="Email"
                    value={email}
                    style={modeloNovo ? undefined : {border: `1px solid ${cor_font}`,color: cor_font}}
                    id="Email_id"
                    onChange={onChangeEmail}
                />
                {detailsProperties.aluguel && detailsProperties.venda ?
                    <>
                        <label className={styles.title_form_one1}>
                            SELECIONE SEU INTERESSE:
                        </label>
                        <ButtonGroup disableElevation variant="contained" color="primary" style={{ marginBottom: "15px" }}>
                            <Button
                                onClick={selectTransacao}
                                style={{
                                    borderRadius: "30px 0px 0px 30px",
                                    ...(interesse == "Venda"
                                        ? site?.cor2 == "#ffffff"
                                            ? { backgroundColor: "gray", border: "0.5px solid #707070" }
                                            : { backgroundColor: site?.cor2, border: "0.5px solid #707070" }
                                        : { backgroundColor: "white", color: "#3d3d3d", border: "0.5px solid #707070" })
                                }}
                            >
                                Venda
                            </Button>
                            <Button
                                onClick={selectTransacao}
                                style={{
                                    borderRadius: "0px 30px 30px 0px",
                                    ...(interesse == "Aluguel"
                                        ? site?.cor2 == "#ffffff"
                                            ? { backgroundColor: "gray", border: "0.5px solid #707070" }
                                            : { backgroundColor: site?.cor2, border: "0.5px solid #707070" }
                                        : { backgroundColor: "white", color: "#3d3d3d", border: "0.5px solid #707070" })
                                }}
                            >
                                Aluguel
                            </Button>
                        </ButtonGroup>
                    </>
                : null}
                <div className={styles.adjust_checkbox}>
                    <Checkbox
                        style={{ color: modeloNovo ? 'inherit' : 'rgb(126, 126, 126)' }}
                        checked={acceptPolitic}
                        onChange={(event, value) => setAcceptPolitic(value)}
                    />
                    <div className={styles.description_form} style={modeloAP ? undefined : {color: cor_font}}>
                        Ao enviar concordo com os
                        <Link prefetch={false} href="/termos">
                            <label className={styles.terms}>
                                termos de uso
                            </label>
                        </Link>
                        e
                        <Link prefetch={false} href="/politica">
                            <label className={styles.terms}>
                                política de privacidade,
                            </label>
                        </Link>
                        {finalidadeAceiteForm(site)} e afirmo ter mais
                        de 18 anos
                    </div>
                </div>
                <a
                    className={
                        acceptPolitic && name != '' && !processando && email != '' && telephone != '' && telephone.length > 10 && telephone.length < 16 && /\S+@\S+\.\S+/.test(email) == true
                            ? styles.action_more
                            : styles.action_more_disabled
                    }
                    onClick={actionSendUser}
                    style={stylesButton}
                >
                    {loadingForm ? (
                        <TailSpin color="white" height={20} width={20} />
                    ) : (
                        'Entrar em contato'
                    )}
                </a>
                <div className={styles.adjust_or}>
                    <div className={styles.line} />
                    <label className={styles.or}>OU</label>
                    <div className={styles.line} />
                </div>
                {!ocultarWhatsappCorretor ?
                    <a
                        data-gtm-text={whatsappInfoUrl}
                        style={modeloNovo ? undefined : {border: `1px solid ${cor_font}`}}
                        className={styles.action_more_whatsapp}
                        href={whatsappInfoUrl}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático

                            trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                            trackMetaEvent(site, 'Contact', {
                                content_ids: [String(detailsProperties?.id)],
                                content_type: 'product',
                                content_name: detailsProperties?.titulo,
                                contact_method: 'whatsapp',
                            });

                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                            window.open(
                                whatsappInfoUrl,
                                "_blank"
                            );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                        }}
                        rel="noopener noreferrer"
                    >
                        <svg
                            viewBox="0 0 16 16"
                            height="24px"
                            width="24px"
                            aria-hidden="true"
                            focusable="false"
                            fill={cor_font}
                            xmlns="http://www.w3.org/2000/svg"
                            className="StyledIconBase-ea9ulj-0 fHrGFt"
                            style={{ marginRight: 10 }}
                        >
                            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                        </svg>
                        <div style={modeloAP ? undefined : {color: cor_font}}>
                            Converse pelo Whatsapp
                        </div>
                    </a>
                : null }
                {ocultarAgendarVisitaCorretor ? null :
                <a
                    className={styles.action_more_whatsapp}
                    style={modeloNovo ? undefined : {border: `1px solid ${cor_font}`,color: cor_font}}
                    href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl}
                    onClick={async (e) => {
                        e.preventDefault(); // Evita o redirecionamento automático

                        trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                        trackMetaEvent(site, 'Contact', {
                            content_ids: [String(detailsProperties?.id)],
                            content_type: 'product',
                            content_name: detailsProperties?.titulo,
                            contact_method: 'schedule_visit',
                        });

                        // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                        setTimeout(() => {
                        window.open(
                            site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl,
                            "_blank"
                        );
                        }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                    }}
                    rel="noopener noreferrer"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="StyledIconBase-ea9ulj-0 fHrGFt"
                        height="24px"
                        width="24px"
                        fill={cor_font}
                        viewBox="0 0 485.213 485.212"
                        style={{ marginRight: 10 }}
                    >
                        <path
                            d="M60.652,75.816V15.163C60.652,6.781,67.433,0,75.817,0c8.38,0,15.161,6.781,15.161,15.163v60.653
                            c0,8.38-6.781,15.161-15.161,15.161C67.433,90.978,60.652,84.196,60.652,75.816z M318.424,90.978
                            c8.378,0,15.163-6.781,15.163-15.161V15.163C333.587,6.781,326.802,0,318.424,0c-8.382,0-15.168,6.781-15.168,15.163v60.653
                            C303.256,84.196,310.042,90.978,318.424,90.978z M485.212,363.906c0,66.996-54.312,121.307-121.303,121.307
                            c-66.986,0-121.302-54.311-121.302-121.307c0-66.986,54.315-121.3,121.302-121.3C430.9,242.606,485.212,296.919,485.212,363.906z
                            M454.89,363.906c0-50.161-40.81-90.976-90.98-90.976c-50.166,0-90.976,40.814-90.976,90.976c0,50.171,40.81,90.98,90.976,90.98
                            C414.08,454.886,454.89,414.077,454.89,363.906z M121.305,181.955H60.652v60.651h60.653V181.955z M60.652,333.584h60.653V272.93
                            H60.652V333.584z M151.629,242.606h60.654v-60.651h-60.654V242.606z M151.629,333.584h60.654V272.93h-60.654V333.584z
                            M30.328,360.891V151.628h333.582v60.653h30.327V94c0-18.421-14.692-33.349-32.843-33.349h-12.647v15.166
                            c0,16.701-13.596,30.325-30.322,30.325c-16.731,0-30.326-13.624-30.326-30.325V60.651H106.14v15.166
                            c0,16.701-13.593,30.325-30.322,30.325c-16.733,0-30.327-13.624-30.327-30.325V60.651H32.859C14.707,60.651,0.001,75.579,0.001,94
                            v266.892c0,18.36,14.706,33.346,32.858,33.346h179.424v-30.331H32.859C31.485,363.906,30.328,362.487,30.328,360.891z
                            M303.256,242.606v-60.651h-60.648v60.651H303.256z M409.399,363.906h-45.49v-45.49c0-8.377-6.781-15.158-15.163-15.158
                            s-15.159,6.781-15.159,15.158v60.658c0,8.378,6.777,15.163,15.159,15.163h60.653c8.382,0,15.163-6.785,15.163-15.163
                            C424.562,370.692,417.781,363.906,409.399,363.906z"
                        />
                    </svg>
                    {site?.id == 2374 ? 'Chamar no WhatsApp' : 'Agendar Visita'}
                </a>
                }
            </div>

        );
    };

    const renderFormStepLast = (type: 'web' | 'mobile') => {
        return (
            <div
                className={
                    type === 'web'
                        ? styles.form_concluded
                        : styles.form_concluded_mobile
                }
            >
                <FaTelegramPlane
                    size={80}
                    color="white"
                    style={{ marginTop: 30, marginBottom: 10 }}
                />
                <label className={styles.congratulations}>Pronto!</label>
                <label className={styles.congratulations_description}>
                    Sua mensagem foi enviada, agora é só aguardar o contato do
                    corretor.
                </label>
                <div
                    className={styles.finish}
                    onClick={resetForm}
                    style={stylesButton}
                >
                    Ok
                </div>
            </div>
        );
    };

    const renderForm = () => {
        if (openForm === 'open') {
            return renderFormStepOne('web');
        }
        if (openForm === 'close') {
            return (
                <div className={styles.column_form}>
                    <button
                        className={styles.action_more}
                        onClick={() => {
                            trackMetaEvent(site, 'ViewContent', {
                                content_ids: [String(detailsProperties?.id)],
                                content_type: 'product',
                                content_name: 'Quero mais informações',
                                content_category: 'property_information',
                            });
                            activeOpenForm();
                        }}
                        style={stylesButton}
                    >
                        Quero mais informações
                    </button>
                    <div className={styles.adjust_or}>
                        <div className={styles.line} />
                        <label className={styles.or}>OU</label>
                        <div className={styles.line} />
                    </div>
                    {!ocultarWhatsappCorretor ?
                        <div className={styles.action_more_whatsapp} style={modeloNovo ? undefined : {border: `1px solid ${cor_font}`}}>
                            <a
                                data-gtm-text={whatsappInfoUrlAlt}
                                className={styles.widthSet}
                                rel="noopener noreferrer"
                                href={whatsappInfoUrlAlt}
                                onClick={async (e) => {
                                    e.preventDefault(); // Evita o redirecionamento automático

                                    trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                    trackMetaEvent(site, 'Contact', {
                                        content_ids: [String(detailsProperties?.id)],
                                        content_type: 'product',
                                        content_name: detailsProperties?.titulo,
                                        contact_method: 'realtor_whatsapp',
                                    });

                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                    setTimeout(() => {
                                    window.open(
                                        whatsappInfoUrlAlt,
                                        "_blank"
                                    );
                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                }}
                            >
                                <svg
                                    viewBox="0 0 16 16"
                                    height="24px"
                                    width="24px"
                                    aria-hidden="true"
                                    focusable="false"
                                    fill={cor_font}
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="StyledIconBase-ea9ulj-0 fHrGFt"
                                    style={{ marginRight: 10 }}
                                >
                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
                                </svg>
                                <div style={modeloAP ? undefined : {color: cor_font}}>
                                    Converse pelo Whatsapp
                                </div>
                            </a>
                        </div>
                    :null }
                    {ocultarAgendarVisitaCorretor ? null :
                    <div className={styles.action_more_whatsapp} style={modeloNovo ? undefined : {border: `1px solid ${cor_font}`,color: cor_font}}>
                        <a
                            className={styles.widthSet}
                            rel="noopener noreferrer"
                            href={site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl}
                            onClick={async (e) => {
                                e.preventDefault(); // Evita o redirecionamento automático

                                trackLead(site, detailsProperties); // 🔥 Registra o evento Lead

                                trackMetaEvent(site, 'Contact', {
                                    content_ids: [String(detailsProperties?.id)],
                                    content_type: 'product',
                                    content_name: detailsProperties?.titulo,
                                    contact_method: 'schedule_visit',
                                });

                                // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                setTimeout(() => {
                                window.open(
                                    site?.id == 1945 ? "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0_4-BSJuo81pw6pAqA4YX4UyBySYbsfwWwoGUflArIMDI1EMOGJOlB2thFm8cRRFQXI78ioUdI" : whatsappVisitUrl,
                                    "_blank"
                                );
                                }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="StyledIconBase-ea9ulj-0 fHrGFt"
                                height="24px"
                                width="24px"
                                fill={cor_font}
                                viewBox="0 0 485.213 485.212"
                                style={{ marginRight: 10 }}
                            >
                                <path
                                    d="M60.652,75.816V15.163C60.652,6.781,67.433,0,75.817,0c8.38,0,15.161,6.781,15.161,15.163v60.653
                                    c0,8.38-6.781,15.161-15.161,15.161C67.433,90.978,60.652,84.196,60.652,75.816z M318.424,90.978
                                    c8.378,0,15.163-6.781,15.163-15.161V15.163C333.587,6.781,326.802,0,318.424,0c-8.382,0-15.168,6.781-15.168,15.163v60.653
                                    C303.256,84.196,310.042,90.978,318.424,90.978z M485.212,363.906c0,66.996-54.312,121.307-121.303,121.307
                                    c-66.986,0-121.302-54.311-121.302-121.307c0-66.986,54.315-121.3,121.302-121.3C430.9,242.606,485.212,296.919,485.212,363.906z
                                    M454.89,363.906c0-50.161-40.81-90.976-90.98-90.976c-50.166,0-90.976,40.814-90.976,90.976c0,50.171,40.81,90.98,90.976,90.98
                                    C414.08,454.886,454.89,414.077,454.89,363.906z M121.305,181.955H60.652v60.651h60.653V181.955z M60.652,333.584h60.653V272.93
                                    H60.652V333.584z M151.629,242.606h60.654v-60.651h-60.654V242.606z M151.629,333.584h60.654V272.93h-60.654V333.584z
                                    M30.328,360.891V151.628h333.582v60.653h30.327V94c0-18.421-14.692-33.349-32.843-33.349h-12.647v15.166
                                    c0,16.701-13.596,30.325-30.322,30.325c-16.731,0-30.326-13.624-30.326-30.325V60.651H106.14v15.166
                                    c0,16.701-13.593,30.325-30.322,30.325c-16.733,0-30.327-13.624-30.327-30.325V60.651H32.859C14.707,60.651,0.001,75.579,0.001,94
                                    v266.892c0,18.36,14.706,33.346,32.858,33.346h179.424v-30.331H32.859C31.485,363.906,30.328,362.487,30.328,360.891z
                                    M303.256,242.606v-60.651h-60.648v60.651H303.256z M409.399,363.906h-45.49v-45.49c0-8.377-6.781-15.158-15.163-15.158
                                    s-15.159,6.781-15.159,15.158v60.658c0,8.378,6.777,15.163,15.159,15.163h60.653c8.382,0,15.163-6.785,15.163-15.163
                                    C424.562,370.692,417.781,363.906,409.399,363.906z"
                                />
                            </svg>
                            {site?.id == 2374 ? 'Chamar no WhatsApp' : 'Agendar Visita'}
                        </a>
                    </div>
                    }
                </div>
            );
        }
        if (openForm === 'concluded') {
            return renderFormStepLast('web');
        }
    };

    const actionViewProperties = async (user: any) => {
        try {
            if(detailsProperties?.id)
                await viewProperties(detailsProperties?.id, user?.id_client || '', origin, codsite);
        } catch (error) {
            // console.log(error)
        }
    };

    // Função que constrói a string de dimensão com base na lógica original
    const renderDimensions = (): string => {
        // Extrai os valores ou define como string vazia se forem undefined/nulos
        const frente = detailsProperties?.frente || "";
        const fundos = detailsProperties?.fundos || "";
        const ladoEsquerdo = detailsProperties?.lado_esquerdo || "";
        const ladoDireito = detailsProperties?.lado_direito || "";

        // Se pelo menos um valor estiver presente
        if (frente || fundos || ladoEsquerdo || ladoDireito) {
        let dimensao = "";

        // Caso 1: frente igual a fundos e ladoEsquerdo igual a ladoDireito
        if (frente === fundos && ladoEsquerdo === ladoDireito) {
            let ld = ladoDireito;
            // Se ambos estiverem preenchidos, adiciona " x " antes do ladoDireito
            if (ld && frente) {
            ld = " x " + ld;
            }
            dimensao = frente + ld;
        }
        // Caso 2: frente igual a fundos, mas ladoEsquerdo diferente de ladoDireito
        else if (frente === fundos && ladoEsquerdo !== ladoDireito) {
            let f = frente;
            let le = ladoEsquerdo;
            if (f) {
            f = f + " x ";
            }
            if (le) {
            le = le + " x ";
            }
            dimensao = f + le + ladoDireito;
        }
        // Caso 3: frente diferente de fundos e ladoEsquerdo igual a ladoDireito
        else if (frente !== fundos && ladoEsquerdo === ladoDireito) {
            let f = frente;
            let le = ladoEsquerdo;
            if (le) {
            le = "x" + le;
            }
            if (f) {
            f = f + " x ";
            }
            dimensao = f + fundos + le;
        }
        // Caso 4: frente diferente de fundos e ladoEsquerdo diferente de ladoDireito
        else if (frente !== fundos && ladoEsquerdo !== ladoDireito) {
            let f = frente;
            let fund = fundos;
            let le = ladoEsquerdo;
            if (f) {
            f = f + " x ";
            }
            if (fund) {
            fund = fund + " x ";
            }
            if (le) {
            le = le + " x ";
            }
            dimensao = f + le + ladoDireito;
        }
        return dimensao;
        }
        return "";
    };

    useEffect(() => {
        try {
            const getUser: any = localStorage.getItem('user');
            const splitUser = JSON.parse(getUser || '');
            setExistUser(splitUser);
            setIsEffect(true);
        } catch (error) {}
    }, [openForm]);

    useEffect(() => {
        if (existUser) {
            setName(existUser?.name || '');
            setEmail(existUser?.email || '');
            setTelephone(existUser?.telephone || '');
            if (openForm === 'concluded') {
                actionViewProperties(existUser);
            }
        }
    }, [existUser]);

    useEffect(() => {
        if (isEffect) {
            actionViewProperties(existUser);
        }else {
            actionViewProperties(undefined);
        }
    }, [isEffect]);

    return (
        <div className={styles.oneStep}>
                {size?.width <= 750 ? (
            <div
                className={styles.button_form}
                onClick={activeOpenForm}
                style={{
                    ...stylesButton,
                    ...mobileInterestButtonStyle
                }}
            >
                {Number(site?.id) === 2451 ? 'Quero mais informações' : 'Tenho interesse'}
            </div>
        ) : null}
            {size?.width <= 750 && openForm !== 'close' ? (
                <>
                    {openForm === 'open' ? renderFormStepOne('mobile') : null}
                    {openForm === 'concluded'
                        ? renderFormStepLast('mobile')
                        : null}
                </>
            ) : null}
            {site?.modelo_pagina_imovel == 1 ?
                <>
                    <label className={styles.title} style={larissa || metropole ? undefined : {color: cor_font}}>
                        {site?.id == 2178 && detailsProperties?.origem == "Orulo" ? `${
                        detailsProperties?.tipo?.nome || ''
                    } em ${detailsProperties?.cidade?.nome || ''}` :`
                        ${detailsProperties?.bairro?.nome ? (detailsProperties?.bairro?.nome + ", ") : ''}
                        ${detailsProperties?.cidade?.nome || ''}
                        ${detailsProperties?.empreendimento?.nome && site?.exibir_empreendimento ? " - "+detailsProperties?.empreendimento?.nome : ''}
                        `}
                    </label>
                    {site?.id != 2178 || detailsProperties?.origem != "Orulo" ?
                    <label className={styles.subtitle} style={modeloNovo ? undefined : {color: cor_font}}>{`${
                        detailsProperties?.tipo?.nome || ''
                    } em ${detailsProperties?.cidade?.nome || ''}`}</label>: null}
                    {canShowPropertyAddress(detailsProperties, site) ?
                        <label className={styles.endereco}>{formatPropertyAddress(detailsProperties, site, { includeLabel: true })}</label>
                    : null}
                </>
            : null}
            <div className={styles.container_info} style={site?.modelo_pagina_imovel >= 3 && !modeloNovo ? {padding: "0px 2.5%"} : {}}>
                <div className={styles.info_properties} style={site?.modelo_pagina_imovel >= 3 ? {width: "calc(100% - 400px)"} : {}}>
                    {site?.modelo_pagina_imovel == 1 ?
                    <>
                        <label className={modeloNovo ? styles.codigo_ref : undefined} style={larissa || metropole ? undefined : {color: cor_font}}>{`Cod. ${
                            detailsProperties?.referencia || ''
                        }`}</label>
                        { detailsProperties?.temporada && detailsProperties?.d1 > 0
                        ? (
                            <label
                                className={
                                    styles.text_price
                                }
                                style={{color: cor_font}}
                            >
                                {site?.id != '1667' ?
                                    <>
                                {textoPreco('Diária', precoOuTexto(precoVivo, detailsProperties?.d1, simboloMoeda, `${simboloMoeda} ${toPrice(detailsProperties?.d1, 2)}`, '', false))}
                                </>
                                : <>{textoPreco('Diária', 'Sob Consulta')}</>}
                            </label>
                        ) : null}
                        {detailsProperties?.venda ?
                            Number(
                                detailsProperties?.exibir_preco_venda &&
                                    detailsProperties?.preco_venda
                            ) ? (
                                <label
                                    className={
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda
                                            ? styles.text_price_oferta
                                            : styles.text_price
                                    }
                                    style={{color: cor_font}}
                                >
                                    {textoPreco('Venda', precoOuTexto(precoVivo, detailsProperties?.preco_venda, simboloMoeda, `${simboloMoeda} ${toPrice(detailsProperties?.preco_venda, 2)}`, '', !detailsProperties?.preco_especial?.preco_especial_venda))}
                                </label>
                            ) : <label
                                    className={
                                        // Internacional: "Valor sob consulta" nunca sai riscado (não há preço antigo a riscar)
                                        detailsProperties?.preco_especial
                                            ?.preco_especial_venda && !internacionalFicha
                                            ? styles.text_price_oferta
                                            : styles.text_price
                                    }
                                    style={{color: cor_font}}
                                >
                                    {textoPreco('Venda', 'Valor sob Consulta')}
                                </label> : null}
                        {detailsProperties?.venda ?
                            detailsProperties?.preco_especial?.preco_especial_venda &&
                                detailsProperties?.exibir_preco_venda &&
                                detailsProperties?.preco_venda ? (
                                <label className={styles.text_price} style={larissa || metropole ? undefined : {color: cor_font}}>
                                    {textoPreco('Por', precoOuTexto(precoVivo, detailsProperties?.preco_especial?.preco_especial_venda, simboloMoeda, `${simboloMoeda} ${toPrice(detailsProperties?.preco_especial?.preco_especial_venda, 2)}`, '', true))}
                                </label>
                            ) : null
                            :null
                        }

                        {Number(
                            detailsProperties?.aluguel &&
                                detailsProperties?.exibir_preco_locacao &&
                                detailsProperties?.preco_locacao
                        ) ? (
                            <label
                                className={
                                    detailsProperties?.preco_especial
                                        ?.preco_especial_locacao
                                        ? styles.text_price_oferta
                                        : styles.text_price
                                }
                                style={{color: cor_font}}
                            >
                                {textoPreco('Aluguel', precoOuTexto(precoVivo, detailsProperties?.preco_locacao, simboloMoeda, `${simboloMoeda} ${toPrice(detailsProperties?.preco_locacao, 2)}`, '', !detailsProperties?.preco_especial?.preco_especial_locacao))}
                            </label>
                        ) : null}

                        {detailsProperties?.aluguel &&
                        detailsProperties?.preco_especial
                            ?.preco_especial_locacao &&
                        detailsProperties?.exibir_preco_locacao &&
                        detailsProperties?.preco_locacao ? (
                            <label className={styles.text_price} style={larissa || metropole ? undefined : {color: cor_font}}>
                                {textoPreco('Por', precoOuTexto(precoVivo, detailsProperties?.preco_especial?.preco_especial_locacao, simboloMoeda, `${simboloMoeda} ${toPrice(detailsProperties?.preco_especial?.preco_especial_locacao, 2)}`, '', true))}
                            </label>
                        ) : null}
                        {detailsProperties?.exibir_preco_iptu &&
                        detailsProperties?.preco_iptu > 0 ? (
                            <label style={{color: cor_font}}>{precoOuTexto(precoVivo, detailsProperties?.preco_iptu, simboloMoeda, `${simboloMoeda} ${toPrice(detailsProperties?.preco_iptu, 2)}`, 'IPTU: ')}</label>
                        ) : null}
                        {detailsProperties?.exibir_preco_condominio &&
                        detailsProperties?.preco_condominio > 0 ? (
                            <label style={{color: cor_font}}>{precoOuTexto(precoVivo, detailsProperties?.preco_condominio, simboloMoeda, `${simboloMoeda} ${toPrice(detailsProperties?.preco_condominio, 2)}`, `CONDOMÍNIO: ${site2551CondominioPrefix}`, false, `${site2551CondominioAddendum}`)}</label>
                        ) : null}
                        {detailsProperties?.aluguel && (detailsProperties?.preco_especial?.preco_especial_locacao > 0 || detailsProperties?.preco_locacao > 0) && site?.id == 747 && (detailsProperties?.exibir_preco_locacao && detailsProperties?.preco_locacao) && ((detailsProperties?.exibir_preco_condominio && detailsProperties?.preco_condominio) || (detailsProperties?.exibir_preco_iptu && detailsProperties?.preco_iptu > 0)) ?
                            <label style={{fontWeight: 'bold', fontSize: 24,color: cor_font}}>
                                {precoOuTexto(precoVivo, calcularTotal(
                                    detailsProperties?.preco_especial?.preco_especial_locacao ? Number(detailsProperties?.preco_especial?.preco_especial_locacao) : Number(detailsProperties?.preco_locacao),
                                    detailsProperties?.exibir_preco_condominio ? Number(detailsProperties?.preco_condominio) || 0 : 0,
                                    detailsProperties?.exibir_preco_iptu ? Number(detailsProperties?.preco_iptu) || 0 : 0
                                ), simboloMoeda, `${simboloMoeda} ${toPrice(calcularTotal(
                                    detailsProperties?.preco_especial?.preco_especial_locacao ? Number(detailsProperties?.preco_especial?.preco_especial_locacao) : Number(detailsProperties?.preco_locacao),
                                    detailsProperties?.exibir_preco_condominio ? Number(detailsProperties?.preco_condominio) || 0 : 0,
                                    detailsProperties?.exibir_preco_iptu ? Number(detailsProperties?.preco_iptu) || 0 : 0
                                ),2)}`, 'Total: ')}
                            </label>
                            : null
                        }
                    </>
                    : null}
                    <p className={isSite2551 ? `${styles.title_caracters} ${styles.font_mini1}` : styles.title_caracters} data-fm1 style={{color: cor_font}}>
                        {titulosEmFrase ? <><b>Características </b>do imóvel</> : <><b>CARACTERÍSTICAS </b>DO IMÓVEL</>}
                    </p>
                    {detailsProperties?.tipo?.nome
                        ? RenderDetails(
                              'Tipo do Imóvel',
                              detailsProperties?.tipo?.nome || 0
                          )
                        : null}
                    {detailsProperties?.area_construida > 0
                        ? RenderDetails(
                              'Área Construída',
                              NumeroFormatado(Number(detailsProperties?.area_construida)) + " " + ('m²')
                          )
                        : null}
                    {detailsProperties?.area_total > 0
                        ? RenderDetails(
                              'Área Total',
                              NumeroFormatado(Number(detailsProperties?.area_total)) + " m²"
                          )
                        : null}
                    {/* Só o Terreno usa a unidade escolhida no cadastro (AreaTipo) */}
                    {detailsProperties?.terreno > 0
                        ? RenderDetails(
                              'Terreno',
                              NumeroFormatado(Number(detailsProperties?.terreno)) + " " + areaTipo
                          )
                        : null}
                    {detailsProperties?.area_privativa > 0
                        ? RenderDetails(
                              'Área Privativa',
                              NumeroFormatado(Number(detailsProperties?.area_privativa)) + " m²"
                          )
                        : null}
                    {
                        detailsProperties?.lado_direito ||
                        detailsProperties?.lado_esquerdo ||
                        detailsProperties?.frente ||
                        detailsProperties?.fundos ? (
                            RenderDetails('Dimensões', renderDimensions())
                        ) : null
                    }
                    {detailsProperties?.area_util > 0
                        ? RenderDetails(
                              'Área Útil',
                              NumeroFormatado(Number(detailsProperties?.area_util)) + " m²"
                          )
                        : null}
                    {detailsProperties?.dormitorios > 0 && detailsProperties?.dormitorios >= detailsProperties?.suites
                    ? RenderDetails(
                            'Quartos',
                            `${detailsProperties?.dormitorios || 0} ${detailsProperties?.suites > 0 ? detailsProperties?.suites == 1 ? " (Sendo 1 Suíte)" : " (Sendo "+detailsProperties?.suites+" Suítes)" : ""}`
                        )
                    :
                        <>
                            {detailsProperties?.dormitorios > 0
                            ? RenderDetails(
                                    'Quartos',
                                    detailsProperties?.dormitorios || 0
                                )
                            : null}
                            {detailsProperties?.suites > 0
                            ? RenderDetails(
                                    'Suítes',
                                    detailsProperties?.suites || 0
                                )
                            : null}
                        </>
                    }
                    {detailsProperties?.banheiros > 0
                        ? RenderDetails(
                              'Banheiros',
                              detailsProperties?.banheiros || 0
                          )
                        : null}
                    {detailsProperties?.garagems > 0
                        ? RenderDetails(
                              'Vagas',
                              detailsProperties?.garagems || 0
                          )
                        : null}
                    {detailsProperties?.posicao_solar
                    ? RenderDetails(
                            'Posição Solar',
                            detailsProperties?.posicao_solar || ""
                        )
                    : null}
                    {formatarDataEntrega(Number(detailsProperties?.data_entrega)) != "false" && detailsProperties?.data_entrega && site?.mostrar_data_entrega
                        ? RenderDetails(
                              'Data de Entrega',
                              formatarDataEntrega(Number(detailsProperties?.data_entrega))
                          )
                    : null}
                    {(site?.id == "1892" || site?.id == "2471") && detailsProperties?.data_edicao ?
                        <label style={{margin: "20px 0px 0px 0px", fontSize: "14px",color: cor_font}}>Data última edição: {arrumaData(detailsProperties?.data_edicao)}</label>
                    : null}
                    {detailsProperties?.incorporacao ?
                        <p className={styles.title_caracters} style={{color: cor_font}}><b>{titulosEmFrase ? 'Incorporação:' : 'INCORPORAÇÃO:'}</b> {detailsProperties?.incorporacao}</p>
                    : null
                    }
                    <p className={styles.title_caracters} data-fm1 style={{color: cor_font}}>
                    {titulosEmFrase ? <><b>Descrição </b>do imóvel</> : <><b>DESCRIÇÃO </b>DO IMÓVEL</>}
                    </p>
                    {site?.Dados?.inicio_txt_descricao ? (
                        <TagTexto className={styles.description_properties} data-fm style={{color: cor_font, ...alinhamentoDescricao}}>
                            {Desc(site?.Dados?.inicio_txt_descricao)}
                    </TagTexto>
                    ) : null}
                    {detailsProperties?.descricao ? (
                        <div>
                            <div
                                ref={textoRef}
                                data-fm
                                className={`${styles.description_properties} ${
                                    expandido || !exibirBotao ? styles.expandido : styles.colapsado
                                }`}
                                style={alinhamentoDescricao}
                            >
                                <TagTexto
                                    dangerouslySetInnerHTML={{
                                        __html: Desc2(descricao_limpa),
                                    }}
                                    style={{color: cor_font}}
                                ></TagTexto>
                            </div>
                            {exibirBotao ?
                                <button
                                    className={styles.toggleButton}
                                    onClick={() => setExpandido(!expandido)}
                                >
                                    {expandido ? (
                                        <span><FaChevronUp style={{marginRight: "5px"}}/>Ver menos</span>
                                    ) : (
                                        <span><FaChevronDown style={{marginRight: "5px"}}/>Ver mais</span>
                                    )}
                                </button>
                            : null}
                        </div>
                    ) : null}
                    {shouldShowSite2551RentalWarnings ?
                         <p className={styles.title_caracters} style={{color: cor_font}}>
                            <b>INFORMAÇÕES IMPORTANTES</b> DO IMÓVEL
                        </p>
                    : null}
                    {shouldShowSite2551RentalWarnings ? (
                        <div className={styles.rentalWarningBox} style={{borderColor: cor_font, color: cor_font}}>
                            {rentalWarnings.map((warning, index) => (
                                <p key={`rental-warning-${index}`} className={styles.rentalWarningItem}>
                                    * {warning}
                                </p>
                            ))}
                        </div>
                    ) : site?.Dados?.final_txt_descricao && !isSite899 ? (
                        <div data-fm className={`${styles.description_properties} ${
                                    expandido || !exibirBotao ? styles.expandido : styles.colapsado
                                }`} style={alinhamentoDescricao}>
                            <TagTexto
                                dangerouslySetInnerHTML={{
                                    __html: Desc2(site?.Dados?.final_txt_descricao),
                                }}
                                style={{color: cor_font}}
                            ></TagTexto>
                        </div>
                    ) : null}
                    { detailsProperties?.caracteristicas?.length > 0  ? (
                        <>
                            {caracteristicasFiltradas.unidade.length > 0 ?
                                <>
                                    <p className={styles.title_caracters} data-fm1 style={{color: cor_font}}>
                                        {titulosEmFrase ? <><b>Características </b>da unidade</> : <><b>CARACTERÍSTICAS </b>DA UNIDADE</>}
                                    </p>
                                    <div className={styles.all_caracters} style={{color: cor_font}}>
                                        {caracteristicasFiltradas.unidade.map((nome: string, index: number) =>
                                            RenderInfoAdditionals(nome, `carac-unidade-${index}`)
                                        )}
                                    </div>
                                </>
                            : null }
                            {caracteristicasFiltradas.condominio.length > 0 ?
                                <>
                                    <p className={styles.title_caracters} data-fm1 style={{color: cor_font}}>
                                        {titulosEmFrase ? <><b>Características </b>do empreendimento</> : <><b>CARACTERÍSTICAS </b>DO EMPREENDIMENTO</>}
                                    </p>
                                    <div className={styles.all_caracters} style={{color: cor_font}}>
                                        {caracteristicasFiltradas.condominio.map((nome: string, index: number) =>
                                            RenderInfoAdditionals(nome, `carac-condominio-${index}`)
                                        )}
                                    </div>
                                </>
                            : null
                            }
                        </>
                    ) : null }
                    { site?.exibir_cidade_bairro_no_imovel && (detailsProperties?.cidade?.descricao || detailsProperties?.bairro?.descricao) ? (
                        <>
                            { detailsProperties?.cidade?.descricao &&
                                <div className={styles.descricao_local}>
                                    {detailsProperties?.cidade?.url_foto &&
                                        <Image
                                            className={styles.descricao_local_imagem}
                                            src={detailsProperties?.cidade?.url_foto}
                                            alt={`Foto da cidade ${detailsProperties?.cidade?.nome}`}
                                            width={250}
                                            height={250}
                                        />
                                    }
                                    <div className={styles.descricao_localizacao} data-fm1 style={{color: cor_font}}>
                                        <b style={{fontSize: 22}}>{titulosEmFrase ? `Conheça a cidade ${detailsProperties?.cidade?.nome ?? ''}` : <>CONHEÇA A CIDADE {detailsProperties?.cidade?.nome.toUpperCase()}</>}</b>
                                        {Desc1(detailsProperties?.cidade?.descricao)}
                                    </div>
                                </div>
                            }
                            { detailsProperties?.bairro?.descricao &&
                                <div className={styles.descricao_local}>
                                    {detailsProperties?.bairro?.url_foto &&
                                        <Image
                                            className={styles.descricao_local_imagem}
                                            src={detailsProperties?.bairro?.url_foto}
                                            alt={`Foto do bairro ${detailsProperties?.bairro?.nome}`}
                                            width={250}
                                            height={250}
                                        />
                                    }
                                    <div className={styles.descricao_localizacao} data-fm1 style={{color: cor_font}}>
                                        <b style={{fontSize: 22}}>{titulosEmFrase ? `Conheça o bairro ${detailsProperties?.bairro?.nome ?? ''}` : <>CONHEÇA O BAIRRO {detailsProperties?.bairro?.nome.toUpperCase()}</>}</b>
                                        {Desc1(detailsProperties?.bairro?.descricao)}
                                    </div>
                                </div>
                            }
                        </>
                    ) : null }
                </div>
                <div className={styles.adjust_form}>
                    {(url && site?.modelo_pagina_imovel == 1) || site?.id == 2246 ?
                        <div className={isSite1630 ? `${styles.compartilharContainer} ${styles.compartilharAfastado}` : styles.compartilharContainer}>
                                <span style={{color: cor_font}}>Compartilhe</span>
                                {site?.id != "1925" ?
                                    <div className={styles.icones}>
                                        {site?.id == 2246 ?
                                            <a href={`https://pinterest.com/pin/create/button/?url=${url}`} target="_blank" rel="noopener noreferrer">
                                                <FaPinterest style={{height: 30, width: 25}}/>
                                            </a>
                                        : null}
                                        <a href={`https://api.whatsapp.com/send?text=${url}`} target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"/><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"/><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/><path fill="#fff" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"/></svg></a>
                                        <a href={`https://www.linkedin.com/signup/cold-join?session_redirect=${url}`} target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#0288d1" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"/><path fill="#fff" d="M14 19H18V34H14zM15.988 17h-.022C14.772 17 14 16.11 14 14.999 14 13.864 14.796 13 16.011 13c1.217 0 1.966.864 1.989 1.999C18 16.11 17.228 17 15.988 17zM35 24.5c0-3.038-2.462-5.5-5.5-5.5-1.862 0-3.505.928-4.5 2.344V19h-4v15h4v-8c0-1.657 1.343-3 3-3s3 1.343 3 3v8h4C35 34 35 24.921 35 24.5z"/></svg></a>
                                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#039be5" d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"/><path fill="#fff" d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"/></svg></a>
                                        <a href={`https://twitter.com/intent/tweet?url=${url}`} target="_blank" rel="noopener noreferrer" aria-label="Compartilhar no X"><svg viewBox="0 0 24 24" width="26px" height="26px" style={{margin: 2}}><path fill={cor_font} d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></a>
                                    </div> :
                                    <div className={styles.icones}>
                                        <a href={`https://api.whatsapp.com/send?text=${url}`} target="_blank" rel="noopener noreferrer"><svg viewBox="0 0 48 48" width="30px" height="30px"><path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"/><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"/><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/><path fill="#fff" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"/></svg></a>
                                    </div>
                                }
                        </div>
                    :null}
                    {(managerActual?.id && managerActual?.url_foto) ? (
                        <div className={styles.info_manager}>
                            <label className={styles.description_manager_top} data-fm style={modeloAP ? undefined : {color: cor_font}}>
                                Corretor responsável por esse imóvel
                            </label>
                            <label className={styles.title_manager} data-fm style={modeloAP ? undefined : {color: cor_font}}>
                                {managerActual?.nome}
                            </label>
                            {site?.id != '2091' ?
                                <label className={site?.id == 2379 ? `${styles.title_manager} ${styles.description_manager}` : styles.description_manager} style={modeloAP ? undefined : {color: cor_font}}>
                                    {managerActual?.funcao?.nome}
                                </label>
                            : null}
                            {managerActual?.creci ?
                                <label className={site?.id == 2379 ? `${styles.title_manager} ${styles.description_manager}` : styles.description_manager} style={modeloAP ? undefined : {color: cor_font}}>
                                    Creci: {managerActual?.creci}
                                </label>
                            :null}
                            {managerActual?.url_foto ? (
                                <Image
                                    className={styles.img_manager}
                                    style={site?.id == 2259 ? {maxWidth: 200, maxHeight: 200} : {}}
                                    src={managerActual?.url_foto}
                                    alt='Foto Corretor'
                                    width={400}
                                    height={400}
                                />
                            ) : null}
                            <div className={styles.adjust_buttons} style={site?.id == 2451 ? { width: '100%', justifyContent: 'center' } : undefined}>
                                <a
                                    href={managerWhatsappUrl}
                                    onClick={() => trackMetaEvent(site, 'Contact', {
                                        content_ids: [String(detailsProperties?.id)],
                                        content_type: 'product',
                                        content_name: detailsProperties?.titulo,
                                        contact_method: 'realtor_whatsapp',
                                    })}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    className={styles.button_zap}
                                    style={site?.id == 2451 ? { width: '90%', padding: '0px' } : undefined}
                                >
                                    WHATSAPP
                                </a>
                                {ocultarInstagramCorretor ? null :
                                    !isMobile && managerActual?.instagram ?
                                    <a
                                        href={managerActual?.instagram}
                                        onClick={() => trackMetaEvent(site, 'ViewContent', {
                                            content_ids: [String(detailsProperties?.id)],
                                            content_type: 'product',
                                            content_name: 'Instagram do corretor',
                                            content_category: 'realtor_social_profile',
                                        })}
                                        rel="noopener noreferrer"
                                        title="Instagram"
                                        target="_blank"
                                        className={styles.button_instagram}
                                    >
                                        INSTAGRAM
                                    </a>
                                    :
                                    !isMobile && site?.Dados?.instagram ?
                                    <a
                                        href={site?.Dados?.instagram}
                                        onClick={() => trackMetaEvent(site, 'ViewContent', {
                                            content_ids: [String(detailsProperties?.id)],
                                            content_type: 'product',
                                            content_name: 'Instagram do corretor',
                                            content_category: 'realtor_social_profile',
                                        })}
                                        rel="noopener noreferrer"
                                        title="Instagram"
                                        target="_blank"
                                        className={styles.button_instagram}
                                    >
                                        INSTAGRAM
                                    </a>
                                    : null
                                }
                            </div>
                        </div>
                    ) : null}
                    {size?.width > 750 ? (
                        <div className={styles.box}>{renderForm()}</div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default DetailsPiecesProperties;

export const getServerSideProps = async () => ({ notFound: true });
